import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Pages
import LandingPage from '@/pages/LandingPage';
import ExploreToolsPage from '@/pages/ExploreToolsPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import DisclaimerPage from '@/pages/DisclaimerPage';
import NotFound from '@/pages/NotFound';

// Tool Pages - Personal Finance
import BudgetCalculator from '@/pages/tools/BudgetCalculator';
import ExpenseTracker from '@/pages/tools/ExpenseTracker';
import SavingsGoalCalculator from '@/pages/tools/SavingsGoalCalculator';
import EmergencyFundCalculator from '@/pages/tools/EmergencyFundCalculator';
import NetWorthCalculator from '@/pages/tools/NetWorthCalculator';

// Tool Pages - Investment
import SIPCalculator from '@/pages/tools/SIPCalculator';
import LumpsumCalculator from '@/pages/tools/LumpsumCalculator';
import CompoundInterestCalculator from '@/pages/tools/CompoundInterestCalculator';
import StockReturnCalculator from '@/pages/tools/StockReturnCalculator';
import DividendCalculator from '@/pages/tools/DividendCalculator';
import MutualFundCalculator from '@/pages/tools/MutualFundCalculator';

// Tool Pages - Loan & Credit
import EMICalculator from '@/pages/tools/EMICalculator';
import HomeLoanCalculator from '@/pages/tools/HomeLoanCalculator';
import CarLoanCalculator from '@/pages/tools/CarLoanCalculator';
import PersonalLoanCalculator from '@/pages/tools/PersonalLoanCalculator';
import CreditCardCalculator from '@/pages/tools/CreditCardCalculator';
import LoanEligibilityCalculator from '@/pages/tools/LoanEligibilityCalculator';

// Tool Pages - Tax & Salary
import IncomeTaxCalculator from '@/pages/tools/IncomeTaxCalculator';
import SalaryBreakdownCalculator from '@/pages/tools/SalaryBreakdownCalculator';
import TakeHomeSalaryCalculator from '@/pages/tools/TakeHomeSalaryCalculator';
import GSTCalculator from '@/pages/tools/GSTCalculator';
import TDSCalculator from '@/pages/tools/TDSCalculator';

// Tool Pages - Business
import ProfitMarginCalculator from '@/pages/tools/ProfitMarginCalculator';
import BreakEvenCalculator from '@/pages/tools/BreakEvenCalculator';
import ROICalculator from '@/pages/tools/ROICalculator';
import BusinessValuationCalculator from '@/pages/tools/BusinessValuationCalculator';
import CashFlowCalculator from '@/pages/tools/CashFlowCalculator';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/explore" element={<ExploreToolsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          
          {/* Personal Finance Tools */}
          <Route path="/tools/budget-calculator" element={<BudgetCalculator />} />
          <Route path="/tools/expense-tracker" element={<ExpenseTracker />} />
          <Route path="/tools/savings-goal-calculator" element={<SavingsGoalCalculator />} />
          <Route path="/tools/emergency-fund-calculator" element={<EmergencyFundCalculator />} />
          <Route path="/tools/net-worth-calculator" element={<NetWorthCalculator />} />
          
          {/* Investment Tools */}
          <Route path="/tools/sip-calculator" element={<SIPCalculator />} />
          <Route path="/tools/lumpsum-calculator" element={<LumpsumCalculator />} />
          <Route path="/tools/compound-interest-calculator" element={<CompoundInterestCalculator />} />
          <Route path="/tools/stock-return-calculator" element={<StockReturnCalculator />} />
          <Route path="/tools/dividend-calculator" element={<DividendCalculator />} />
          <Route path="/tools/mutual-fund-calculator" element={<MutualFundCalculator />} />
          
          {/* Loan & Credit Tools */}
          <Route path="/tools/emi-calculator" element={<EMICalculator />} />
          <Route path="/tools/home-loan-calculator" element={<HomeLoanCalculator />} />
          <Route path="/tools/car-loan-calculator" element={<CarLoanCalculator />} />
          <Route path="/tools/personal-loan-calculator" element={<PersonalLoanCalculator />} />
          <Route path="/tools/credit-card-calculator" element={<CreditCardCalculator />} />
          <Route path="/tools/loan-eligibility-calculator" element={<LoanEligibilityCalculator />} />
          
          {/* Tax & Salary Tools */}
          <Route path="/tools/income-tax-calculator" element={<IncomeTaxCalculator />} />
          <Route path="/tools/salary-breakdown-calculator" element={<SalaryBreakdownCalculator />} />
          <Route path="/tools/take-home-salary-calculator" element={<TakeHomeSalaryCalculator />} />
          <Route path="/tools/gst-calculator" element={<GSTCalculator />} />
          <Route path="/tools/tds-calculator" element={<TDSCalculator />} />
          
          {/* Business Tools */}
          <Route path="/tools/profit-margin-calculator" element={<ProfitMarginCalculator />} />
          <Route path="/tools/break-even-calculator" element={<BreakEvenCalculator />} />
          <Route path="/tools/roi-calculator" element={<ROICalculator />} />
          <Route path="/tools/business-valuation-calculator" element={<BusinessValuationCalculator />} />
          <Route path="/tools/cash-flow-calculator" element={<CashFlowCalculator />} />
          
          {/* 404 Not Found - Catch all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
